import { createFileRoute } from '@tanstack/react-router'
import { guardJeridSchoolAdminOnly } from '../../lib/auth/routeGuards'
import ServiceManagementPanel from '@/components/jeridSchoolAdminPage/ServiceManagementPanel'

export const Route = createFileRoute('/jerid_school_admin/services')({
  beforeLoad: guardJeridSchoolAdminOnly,
  component: RouteComponent,
})

function RouteComponent() {
  return <ServiceManagementPanel />
}
